import AVImark from "~images/pages/pims/logos/avimark.png"
import Cornerstone from "~images/pages/pims/logos/cornerstone.png"
import DaySmart from "~images/pages/pims/logos/daysmart.png"
import EzyVet from "~images/pages/pims/logos/ezyVet.png"
import ImproMed from "~images/pages/pims/logos/impromed.png"
import Instinct from "~images/pages/pims/logos/instinct.png"
import Provet from "~images/pages/pims/logos/provet.png"
import Pulse from "~images/pages/pims/logos/pulse.png"
import Rhapsody from "~images/pages/pims/logos/rhapsody.png"
import Shepherd from "~images/pages/pims/logos/shepherd.png"
import Favicon from "~images/logo/favicon.png"

export const PIMS = [
    {
        name: "Covetrus AVImark",
        href: "/pims/avimark",
        logo: AVImark,
        backgroundColor: "#b6c5fa",
        borderColor: "#8a9feb",
    },
    {
        name: "IDEXX Cornerstone",
        href: "/pims/cornerstone",
        logo: Cornerstone,
        backgroundColor: "#fad2d3",
        borderColor: "#f0a3a6",
    },
    {
        name: "DaySmart Vet",
        href: "/pims/daysmart",
        logo: DaySmart,
        backgroundColor: "#e2ecd3",
        borderColor: "#bcd29b",
    },
    {
        name: "EzyVet",
        href: "/pims/ezyvet",
        logo: EzyVet,
        backgroundColor: "#d3f5f1",
        borderColor: "#a1e6dd",
    },
    {
        name: "ImproMed/Infinity",
        href: "/pims/impromed",
        logo: ImproMed,
        backgroundColor: "",
        borderColor: "",
    },
    {
        name: "Instinct",
        href: "/pims/instinct",
        logo: Instinct,
        backgroundColor: "#fcecbb",
        borderColor: "#f5db8c",
    },
    {
        name: "Provet Cloud",
        href: "/pims/provet",
        logo: Provet,
        backgroundColor: "#d6c3f7",
        borderColor: "#ac8be8",
    },
    {
        name: "Covetrus Pulse / eVetPractice",
        href: "/pims/pulse",
        logo: Pulse,
        backgroundColor: "#c3fafa",
        borderColor: "#93e5e6",
    },
    {
        name: "Rhapsody",
        href: "/pims/rhapsody",
        logo: Rhapsody,
        backgroundColor: "#e3cac5",
        borderColor: "#d6aca5",
    },
    {
        name: "Shepherd",
        href: "/pims/shepherd",
        logo: Shepherd,
        backgroundColor: "#cfe0fa",
        borderColor: "#9dbbeb",
    },
]

export const PREVIEW_PIMS = [
    {
        name: "Covetrus AVImark",
        href: "/pims/avimark",
        logo: AVImark,
    },
    // {
    //     name: "IDEXX Cornerstone",
    //     href: "/pims/cornerstone",
    //     logo: Cornerstone,
    // },
    {
        name: "DaySmart Vet",
        href: "/pims/daysmart",
        logo: DaySmart,
    },
    {
        name: "EzyVet",
        href: "/pims/ezyvet",
        logo: EzyVet,
    },
    {
        name: "ImproMed/Infinity",
        href: "/pims/impromed",
        logo: ImproMed,
    },
    {
        name: "Provet Cloud",
        href: "/pims/provet",
        logo: Provet,
    },
    {
        name: "Covetrus Pulse / eVetPractice",
        href: "/pims/pulse",
        logo: Pulse,
    },
    {
        name: "Rhapsody",
        href: "/pims/rhapsody",
        logo: Rhapsody,
    },
    {
        name: "Shepherd",
        href: "/pims/shepherd",
        logo: Shepherd,
    },
    {
        name: "...and Many More!",
        href: "/pims",
        logo: Favicon,
    },
]
